import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Footer from '../components/Footer';
import BackToTopButton from '../components/Global/BackToTop';
import Navbar from './Navbar';
export default function LandingPage() {
	const location = useLocation();
	const [windowWidth, setWindowWidth] = useState(window.innerWidth);
	useEffect(() => {
		// Update the window width when the window is resized
		const handleResize = () => {
			setWindowWidth(window.innerWidth);
		};

		// Attach the event listener
		window.addEventListener('resize', handleResize);

		// Cleanup
		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	// Reset scroll to the top whenever the route changes, so navigating between
	// pages (e.g. one service area to another) always starts at the top.
	useEffect(() => {
		window.scrollTo(0, 0);
	}, [location.pathname]);

	const noNav = [
		'/',
		'/login',
		'/signup',
		'/forgot-password',
		'/reset-password',
	];
	const noFooter = ['/login', '/signup'];
	return (
		<div className={''}>
			<div>
				<Navbar />
				<Outlet />
				<BackToTopButton />
				{noFooter.includes(location.pathname) ? null : <Footer />}
			</div>
		</div>
	);
}
